import { request } from '../core';
import { buildURL, Method } from '../core/util';
import { CockpitStatus, CockpitMode } from '@/utils/constant';

export class ChangeCockpitStatus {
  checkUserTakeOver = (): Promise<any> => {
    const requestParams: RequestOptions = {
      path: '/monitor/web/cockpit/enterMode',
      method: Method.POST,
    };
    return request(requestParams);
  };

  quitCockpit = (): Promise<any> => {
    const requestParams: RequestOptions = {
      path: '/monitor/web/cockpit/quitCockpit',
      method: Method.POST,
    };
    return request(requestParams);
  };

  /**
   * 入座座席
   * @param cockpitMode 座席模式
   * @param cockpitNumber 座席编号
   * @returns
   */
  enterCockpit = (cockpitMode: string, cockpitNumber: string): Promise<any> => {
    const requestParams: RequestOptions = {
      path: '/monitor/web/cockpit/enterCockpit',
      method: Method.POST,
      body: {
        cockpitMode,
        cockpitNumber,
      },
    };
    return request(requestParams);
  };

  /**
   * 切换座席状态
   * @param cockpitMode 座席状态
   * @param cockpitNumber 座席编号
   * @param acceptIssueStatus 接单状态
   * @returns
   */
  changeCockpitStatus = (
    cockpitStatus: CockpitStatus,
    cockpitNumber: string,
    acceptIssueStatus: boolean,
  ): Promise<any> => {
    const requestParams: RequestOptions = {
      path: '/monitor/web/cockpit/switchStatus',
      method: Method.POST,
      body: {
        cockpitStatus,
        cockpitNumber,
        acceptIssueStatus,
      },
    };
    return request(requestParams);
  };

  changeCockpitMode = (
    cockpitMode: CockpitMode,
    cockpitNumber: string,
  ): Promise<any> => {
    const requestParams: RequestOptions = {
      path: '/monitor/web/cockpit/switchMode',
      method: Method.POST,
      body: {
        cockpitMode,
        cockpitNumber,
      },
    };
    return request(requestParams);
  };
}
